var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhotos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fec006;}.cls-2{fill:#f34235;}.cls-3{fill:#4bae4f;}.cls-4{fill:#2095f2;}.cls-11,.cls-5{fill:#fff;}.cls-10,.cls-5{isolation:isolate;opacity:0.2;}.cls-6{fill:#9c27b0;}.cls-7{fill:#1ea362;}.cls-8{fill:#3e50b4;}.cls-9{fill:#fe9700;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,25H7.52l8.74-8.74H25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,25V7.52l8.74,8.74V25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.26,25v8.74L25,42.48V25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25,25H42.48l-8.74,8.74H25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25,25l1.25,1.25h15L42.48,25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25,25l8.74-8.74V25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25,25l-8.74,8.74V25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M33.74,33.74,25,25v8.74Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16.26,16.26,25,25V16.26Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25,7.52V8.77l8.74,8.74V16.26Zm-8.74,8.74L7.52,25H8.77l7.49-7.49H25V16.26Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M25,21.26l-1.56,3.43L20,26.25l3.43,1.56L25,31.24l1.56-3.43L30,26.25l-3.43-1.56Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M25,20l-1.56,3.43L20,25l3.43,1.56L25,30l1.56-3.43L30,25l-3.43-1.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotos);
export default __webpack_public_path__ + "static/media/Icon-Photos.179eb204f41d95d33a4b48282764b3df.svg";
export { ForwardRef as ReactComponent };